// extracted by mini-css-extract-plugin
export var changeIcon = "_4o-4";
export var container = "_4o-0";
export var divider = "_4o-7";
export var externalLinkIcon = "_4o-1";
export var green = "_4o-5";
export var helpCircleIcon = "_4o-3";
export var iconButton = "_4o-2";
export var red = "_4o-6";